import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DwiConnect() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0f1e] flex items-center justify-center text-white">
      <div className="text-center">
        <div className="text-4xl mb-4">&#x1F4E1;</div>
        <h1 className="text-2xl font-bold mb-2">DwiConnect</h1>
        <p className="text-white/50 mb-6">WiFi portal coming soon.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-cyan-500 hover:bg-cyan-400 text-[#0a0f1e] font-semibold px-6 py-2.5 rounded-xl text-sm"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
